@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="
      errorMessage() ?? (isArabic() ? 'حدث خطأ أثناء تحميل الفواتير' : 'An error occurred while loading invoices')
    "
    [showRetry]="true"
    (retry)="getInvoices.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="actions"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="
      isArabic() ? 'لا توجد فواتير تطابق معايير البحث.' : 'No invoices found matching the selected criteria.'
    "
    [emptyContentTitle]="isArabic() ? 'لا توجد فواتير' : 'No Invoices Found'"
    [emptyContentDescription]="isArabic() ? 'لا توجد فواتير في النظام.' : 'No invoices available.'" />

  @if (rows().length > 0) {
    <app-pagination
      [itemsPerPage]="itemsPerPage()"
      [currentPage]="currentPage()"
      [getPageNumbers]="pageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="onPreviousPage()"
      (nextPage)="onNextPage()"
      (goToPage)="onGoToPage($event)"
      (changePageNumber)="onChangePageNumber($event)"
      (pageSizeChange)="onPageSizeChange()" />
  }
}
